import type { Template } from "@/types";

export const PO_05_H2_V3: Template[] = [
    {
        id: "po-05-h2v3-01",
        name: "PO 01 - H2V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h2_v3_01.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 84, y: 182, width: 256, height: 375, rotation: 0, imageRotation: 0 },
            { id: "2", x: 348, y: 182, width: 256, height: 375, rotation: 0, imageRotation: 0 },
            { id: "3", x: 84, y: 565, width: 256, height: 169, rotation: 0, imageRotation: 0 },
            { id: "4", x: 348, y: 565, width: 256, height: 169, rotation: 0, imageRotation: 0 },
            { id: "5", x: 774, y: 81, width: 513, height: 756, rotation: 0, imageRotation: 0 },
        ],
    },

    {
        id: "po-05-h2v3-02",
        name: "PO 02 - H2V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h2_v3_02.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 33, y: 0, width: 621, height: 916, rotation: 0, imageRotation: 0 },
            { id: "2", x: 760, y: 572, width: 267, height: 181, rotation: 0, imageRotation: 0 },
            { id: "3", x: 1035, y: 572, width: 266, height: 181, rotation: 0, imageRotation: 0 },
            { id: "4", x: 760, y: 163, width: 267, height: 402, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1035, y: 163, width: 266, height: 402, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h2v3-03",
        name: "PO 03 - H2V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h2_v3_03.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 33, y: 0, width: 621, height: 916, rotation: 0, imageRotation: 0 },
            { id: "2", x: 760, y: 163, width: 267, height: 181, rotation: 0, imageRotation: 0 },
            { id: "3", x: 760, y: 351, width: 267, height: 402, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1034, y: 163, width: 267, height: 402, rotation: 0, imageRotation: 0 },        
            { id: "5", x: 1034, y: 572, width: 267, height: 181, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h2v3-04",
        name: "PO 04 - H2V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h2_v3_04.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 87, y: 80, width: 513, height: 756, rotation: 0, imageRotation: 0 },
            { id: "2", x: 744, y: 173, width: 547, height: 365, rotation: 0, imageRotation: 0 },
            { id: "3", x: 744, y: 546, width: 131, height: 198, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1161, y: 546, width: 130, height: 198, rotation: 0, imageRotation: 0 },
            { id: "5", x: 883, y: 546, width: 270, height: 198, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h2v3-05",
        name: "PO 05 - H2V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h2_v3_05.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 92, y: 174, width: 497, height: 335, rotation: 0, imageRotation: 0 },
            { id: "2", x: 92, y: 517, width: 329, height: 226, rotation: 0, imageRotation: 0 },
            { id: "3", x: 429, y: 517, width: 160, height: 226, rotation: 0, imageRotation: 0 },
            { id: "4", x: 734, y: 239, width: 293, height: 438, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1035, y: 239, width: 292, height: 438, rotation: 0, imageRotation: 0 }
        ],
    },
    {
        id: "po-05-h2v3-06",
        name: "PO 06 - H2V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h2_v3_06.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 63, y: 254, width: 277, height: 408, rotation: 0, imageRotation: 0 },
            { id: "2", x: 348, y: 254, width: 277, height: 408, rotation: 0, imageRotation: 0 },
            { id: "3", x: 1035, y: 254, width: 287, height: 408, rotation: 0, imageRotation: 0 },
            { id: "4", x: 740, y: 254, width: 287, height: 200, rotation: 0, imageRotation: 0 },
            { id: "5", x: 740, y: 462, width: 287, height: 200, rotation: 0, imageRotation: 0 }
        ],
    },
    {
        id: "po-05-h2v3-07",
        name: "PO 07 - H2V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h2_v3_07.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 0, y: 170, width: 859, height: 576, rotation: 0, imageRotation: 0 },
            { id: "2", x: 867, y: 170, width: 508, height: 336, rotation: 0, imageRotation: 0 },
            { id: "3", x: 867, y: 513, width: 164, height: 233, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1039, y: 513, width: 164, height: 233, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1211, y: 513, width: 164, height: 233, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h2v3-08",
        name: "PO 08 - H2V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h2_v3_08.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 0, y: 170, width: 859, height: 576, rotation: 0, imageRotation: 0 },
            { id: "2", x: 867, y: 170, width: 508, height: 336, rotation: 0, imageRotation: 0 },
            { id: "3", x: 867, y: 513, width: 164, height: 233, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1039, y: 513, width: 164, height: 233, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1211, y: 513, width: 164, height: 233, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h2v3-09",
        name: "PO 09 - H2V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h2_v3_09.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 41, y: 221, width: 317, height: 473, rotation: 0, imageRotation: 0 },
            { id: "2", x: 366, y: 221, width: 317, height: 233, rotation: 0, imageRotation: 0 },
            { id: "3", x: 366, y: 462, width: 317, height: 232, rotation: 0, imageRotation: 0 },
            { id: "4", x: 691, y: 221, width: 317, height: 473, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1016, y: 221, width: 317, height: 473, rotation: 0, imageRotation: 0 },
        ],
    },

    {
        id: "po-05-h2v3-10",
        name: "PO 10 - H2V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h2_v3_10.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 0, y: 206, width: 338, height: 504, rotation: 0, imageRotation: 0 },
            { id: "2", x: 346, y: 206, width: 337, height: 504, rotation: 0, imageRotation: 0 },
            { id: "3", x: 691, y: 206, width: 337, height: 248, rotation: 0, imageRotation: 0 },
            { id: "4", x: 691, y: 462, width: 337, height: 248, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1036, y: 206, width: 337, height: 504, rotation: 0, imageRotation: 0 },
        ],
    },
];


